import { render, staticRenderFns } from "./ContactOrderTable.vue?vue&type=template&id=2ffe6d88&scoped=true&"
import script from "./ContactOrderTable.vue?vue&type=script&lang=js&"
export * from "./ContactOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./ContactOrderTable.vue?vue&type=style&index=0&id=2ffe6d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe6d88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSimpleTable,VTooltip})
